<div class="content">
  <img class="icon" src="../../../assets/icons/continue-learning.svg">
  <p class="title"> Щоб продовжити навчання пройдіть повну реєстрацію </p>
  <p class="subtitle">Ви пройшли безкоштовно першу лекцію та успішно склали проміжний тест. Здійсніть реєстрацію щоб
    продовжити навчання.</p>
</div>
